<div class="shimmer-wrapper" *ngIf="isLoading$ | async">
    <ng-container [ngSwitch]="key">
        <app-storefront-shimmer *ngSwitchCase="RouteKey.Storefront" (error)="handleError($event)"></app-storefront-shimmer>
        <app-myaha-shimmer *ngSwitchCase="RouteKey.MyAha" (error)="handleError($event)"></app-myaha-shimmer>
        <app-default-shimmer *ngSwitchDefault (error)="handleError($event)"></app-default-shimmer>
    </ng-container>
</div>